import { NewsCard, NewsCardPlate, PageSection } from 'components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { NewsListItem } from 'types/rest';
import { HeaderContainer, SubmitButton, Title } from '../../styled';
import { Gradient, NewsDesktopContainer } from './styled';
import { SliderContainer } from '../intro/styled';
import Slider, { Settings } from 'react-slick';
import {
    DotsContainer,
    DotsList,
} from 'containers/pages/for-businesses/components/reviews/styled';
import { SliderStyler } from 'containers/pages/for-businesses/components/courses/styled';

const sectionConfig = {
    CWrap: {
        css: {
            paddingBottom: 70,
            '@media(max-width: 1023px)': {
                paddingBottom: 64,
            },
        },
    },
    ContentArea: {
        css: {
            display: 'block',
            position: 'relative',
            zIndex: 10,

            '@media(max-width: 1023px)': {
                paddingTop: '0 !important',
                paddingBottom: 0,
            },

            '@media(max-width: 767px)': {
                paddingBottom: 100,
            },
        },
    },
};

type NewsProps = {
    items: NewsListItem[] | null;
};

export const News: FC<NewsProps> = ({ items }) => {
    const { t } = useTranslation('pages/academy-alliance');

    if (!items) return null;

    const CAROUSEL_SETTINGS: Settings = {
        slidesToScroll: 2,
        infinite: false,
        slidesToShow: 2,
        arrows: false,
        dots: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToScroll: 1,
                    slidesToShow: 1,
                },
            },
        ],
        appendDots:
            items && items.length > 1
                ? (dots) => (
                      <DotsContainer>
                          <DotsList
                              styles={{
                                  '.slick-active': {
                                      background: '#7733FF',
                                      opacity: '1',
                                  },
                                  li: {
                                      opacity: '0.5',
                                      background: '#7733FF',
                                  },
                              }}>
                              {dots}
                          </DotsList>
                      </DotsContainer>
                  )
                : () => <></>,
    };

    return (
        <PageSection config={sectionConfig}>
            <HeaderContainer>
                <Title>{t('news')}</Title>
                <SubmitButton
                    onClick={() => window.open('/news', '_blank')}
                    variant={'outlined'}
                    color={'secondary'}
                    styles={{ bottom: '24px !important' }}>
                    {t('show-all-news')}
                </SubmitButton>
            </HeaderContainer>
            <NewsDesktopContainer>
                <NewsCardPlate
                    items={items || []}
                    secondary
                    target={'_blank'}
                    isAcademy
                />
            </NewsDesktopContainer>
            <SliderContainer>
                <SliderStyler>
                    <Slider {...CAROUSEL_SETTINGS}>
                        {items.map((item: NewsListItem) => (
                            <NewsCard
                                key={item.id}
                                data={{
                                    imageURL: item.baseImage?.fileLink || '',
                                    title: item.name,
                                    link: `/news/${item.groupName}/`,
                                }}
                                isFirstInBlock
                                secondary
                                target={'_blank'}
                                isAcademy
                            />
                        ))}
                    </Slider>
                </SliderStyler>
            </SliderContainer>
            <Gradient />
        </PageSection>
    );
};
